import { styled } from '@mui/material/styles';
import { Box, SxProps } from '@mui/material';
import { Icon } from '@iconify/react';

interface Props {
  icon: string;
  sx?: SxProps;
  [key: string]: any;
}

const IconWrapper = styled(Box)({
  display: 'inline-flex',
});

export default function Iconify({ icon, sx, ...other }: Props) {
  return (
    <IconWrapper sx={sx} {...other}>
      <Icon icon={icon} />
    </IconWrapper>
  );
}
